@if (!historyData() || !historyData()?.length) {
	<div class="alert alert-info mt-3 text-center" role="alert">Nie znaleziono żadnych historycznych wyników</div>
} @else {
	@for (item of historyData(); track $index) {
		<mat-card class="w-100" appearance="outlined" class="mb-3">
			<mat-card-header>
				<mat-card-title>Autor: {{ item.modifiedBy }}</mat-card-title>
				<mat-card-subtitle>Kiedy: {{ item.modifiedAt | date: 'dd.MM.yyyy, HH:mm' }}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<table mat-table [dataSource]="item.changedFields">
					<ng-container matColumnDef="field">
						<th class="text-center fw-bold" mat-header-cell *matHeaderCellDef>Pole</th>
						<td class="text-center" mat-cell *matCellDef="let element">{{ element.field }}</td>
					</ng-container>

					<ng-container matColumnDef="old">
						<th class="text-center fw-bold" mat-header-cell *matHeaderCellDef>Stara</th>
						<td
							class="text-center text-decoration-line-through text-muted"
							mat-cell
							*matCellDef="let element"
						>
							{{ element.old }}
						</td>
					</ng-container>

					<ng-container matColumnDef="arrow">
						<th class="text-center fw-bold" mat-header-cell *matHeaderCellDef></th>
						<td class="text-center" mat-cell *matCellDef="let element">
							<i class="fa-solid fa-arrow-right-long fs-5"></i>
						</td>
					</ng-container>

					<ng-container matColumnDef="new">
						<th class="text-center fw-bold" mat-header-cell *matHeaderCellDef>Nowa</th>
						<td class="text-center" mat-cell *matCellDef="let element">
							{{ element.new }}
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</mat-card-content>
		</mat-card>
	}
}
